export default __webpack_public_path__ + "static/media/teamwork.d7d973e0.png";